// extracted by mini-css-extract-plugin
export var childrenContainer = "ProductCard-module--childrenContainer--0cc85";
export var detailsContainer = "ProductCard-module--detailsContainer--94b72";
export var divider = "ProductCard-module--divider--8af82";
export var fabricAndColor = "ProductCard-module--fabricAndColor--eac03";
export var hasAltImage = "ProductCard-module--hasAltImage--ff2f7";
export var icon = "ProductCard-module--icon--d6725";
export var imgContainer = "ProductCard-module--imgContainer--a5d24";
export var isInGrid = "ProductCard-module--isInGrid--4e97b";
export var moduleCard = "ProductCard-module--moduleCard--b889d";
export var moduleDetails = "ProductCard-module--moduleDetails--6236b";
export var moduleRatio = "ProductCard-module--moduleRatio--4484a";
export var nameAndPrice = "ProductCard-module--nameAndPrice--d0b2b";
export var productCard = "ProductCard-module--productCard--7a261";
export var rating = "ProductCard-module--rating--0a70f";
export var ratingStars = "ProductCard-module--ratingStars--ea1a2";